/* eslint-disable */
import { useEffect } from "react";

const METHODS = [
  "trackSubmit",
  "trackClick",
  "trackLink",
  "trackForm",
  "pageview",
  "identify",
  "reset",
  "group",
  "track",
  "ready",
  "alias",
  "debug",
  "page",
  "screen",
  "once",
  "off",
  "on",
  "addSourceMiddleware",
  "addIntegrationMiddleware",
  "setAnonymousId",
  "addDestinationMiddleware",
  "register",
];

/**
 * The Segment snippet's call queue, without the script. Installed at startup so events sent before the
 * write key is known (it comes with the platform config) are queued and replayed once analytics.js loads,
 * instead of being dropped.
 */
export const installSegmentQueue = () => {
  const analytics = (window.analytics = window.analytics || []);
  if (analytics.initialize || analytics.invoked) return;
  analytics.invoked = !0;
  analytics.methods = METHODS;
  analytics.factory = function (method) {
    return function () {
      const args = Array.prototype.slice.call(arguments);
      analytics.push([method].concat(args));
    };
  };
  for (let i = 0; i < METHODS.length; i++) {
    analytics[METHODS[i]] = analytics.factory(METHODS[i]);
  }
};

const loadSegment = (writeKey) => {
  installSegmentQueue();
  const analytics = window.analytics;
  if (analytics.initialize || analytics.scriptAdded) return;
  analytics.scriptAdded = !0;
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.async = !0;
  script.src = `https://cdn.segment.com/analytics.js/v1/${writeKey}/analytics.min.js`;
  const first = document.getElementsByTagName("script")[0];
  first.parentNode.insertBefore(script, first);
  // No page call here: TrackPageViews' first page view is already queued.
};

function SegmentScript({ environment }) {
  useEffect(() => {
    let segmentKey = "";
    switch (environment) {
      case "production":
        segmentKey = "Y29mlBAleANFoIYsabKEmZSikJYKB00Z";
        break;
      case "staging":
        segmentKey = "o2xQ0zsnfGHiwFQClS9GDGu76PVusMSi";
        break;
      case "development":
        segmentKey = "b0AGGJKvbTKygLIsfTZefuOjdNL2Z5MA";
        break;
      default:
        console.warn("No Segment key for this environment");
    }

    if (segmentKey) {
      loadSegment(segmentKey);
    }
  }, [environment]);

  return null;
}

export default SegmentScript;
